import {useQuery} from "@tanstack/react-query";
import Api from "../../../api.js";

const INTERVAL_CHECK_IS_READY = 1500

export const usePdfStatus = (url, uuid, enabled = true) => {
    return useQuery({
        queryKey: [`raport_ready__${uuid}`],
        queryFn: () => Api(`${url}/status-pdf/${uuid}`),
        enabled,
        refetchInterval: INTERVAL_CHECK_IS_READY,
    })
}